import { Component, OnInit } from '@angular/core';
import { DistributorService } from '../../services/distributor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PurchaseProductService } from '../../../purchase/services/purchase-product.service';
import { RepurchaseProductService } from '../../../repurchase/services/repurchase-product.service';
import { ConsignmentProductService } from '../../../consignment/services/consignment-product.service';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';

@Component({
  selector: 'app-list-distributor',
  templateUrl: './list-distributor.component.html',
  styleUrls: ['./list-distributor.component.css'],
  providers:[DistributorService, PurchaseProductService,RepurchaseProductService,ConsignmentProductService]
})
export class ListDistributorComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  distributors: any = [];
  filters:any = {
    cif:{contains: ""},
    name: {contains: ""},
    address: {contains: ""},
    telephone: {contains: ""}
  };


  constructor(private distributorService: DistributorService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getDistributors();
  }

  getDistributors(){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    this.distributorService.query(params)
    .subscribe((distributors) => {
        this.distributors = distributors;
        let countParams = {
          where: _.cloneDeep(params.where),
        };
        this.distributorService.count(countParams)
        .subscribe((count) => {
          this.totalItems = count.count;
        });
    }); 
  }
}






// WEBPACK FOOTER //
// ./src/app/distributors/components/list-distributor/list-distributor.component.ts